import React from 'react'
import { DeepPartial } from 'utility-types'
import { TUSL2ReturnsCalculator } from '../../types/page-api-response'
import { USL2WidgetHeading } from './heading'
import ReturnCalculator from '@/components/calculators/all-calculators/returnsCalculator'
import Text from '@/stories/components/Common/NewText'

type TUSL2ReturnsCalculatorProps = {
  widgetData: DeepPartial<TUSL2ReturnsCalculator>
}

const USStockL2ReturnsCalculator = (props: TUSL2ReturnsCalculatorProps) => {
  const { d } = props.widgetData
  if (!d?.calc?.durations?.length) return null
  return (
    <div>
      <USL2WidgetHeading>
        {`Stock Returns calculator for ${d?.companyName} Stock including INR - Dollar returns`}
      </USL2WidgetHeading>
      <Text
        appearance="subtitle2"
        addClassName="text-brand-grey-dark font-normal mb-2"
      >
        {`The ${d.companyName} stock calculator helps Indian investors calculate returns based on the historical performance of the stock. Just choose your investment amount and duration to get insights and invest more confidently. See stock returns as well as the effect of dollar appreciation over different durations.`}
      </Text>
      <Text appearance="caption" addClassName="text-brand-grey-base mb-6">
        *Dollar Return is the profit earned when the US dollar rises in value
        compared to the Indian rupee.
      </Text>
      <ReturnCalculator
        companyName={d.companyName}
        calcData={d.calc}
        minAmount={10000}
        maxAmount={300000}
        stepGap={1000}
      />
    </div>
  )
}

export default USStockL2ReturnsCalculator
